// Auto-generated file

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "accept-invitation": lazy(() => import("@/screens/accept-invitation")),
  consent: lazy(() => import("@/screens/consent")),
  "customized-consent": lazy(() => import("@/screens/customized-consent")),
  "device-code-activation": lazy(
    () => import("@/screens/device-code-activation")
  ),
  "device-code-activation-allowed": lazy(
    () => import("@/screens/device-code-activation-allowed")
  ),
  "device-code-activation-denied": lazy(
    () => import("@/screens/device-code-activation-denied")
  ),
  "device-code-confirmation": lazy(
    () => import("@/screens/device-code-confirmation")
  ),
  "email-identifier-challenge": lazy(
    () => import("@/screens/email-identifier-challenge")
  ),
  "email-otp-challenge": lazy(() => import("@/screens/email-otp-challenge")),
  "email-verification-result": lazy(
    () => import("@/screens/email-verification-result")
  ),
  "interstitial-captcha": lazy(() => import("@/screens/interstitial-captcha")),
  login: lazy(() => import("@/screens/login")),
  "login-email-verification": lazy(
    () => import("@/screens/login-email-verification")
  ),
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "login-passwordless-email-code": lazy(
    () => import("@/screens/login-passwordless-email-code")
  ),
  "login-passwordless-sms-otp": lazy(
    () => import("@/screens/login-passwordless-sms-otp")
  ),
  logout: lazy(() => import("@/screens/logout")),
  "logout-aborted": lazy(() => import("@/screens/logout-aborted")),
  "logout-complete": lazy(() => import("@/screens/logout-complete")),
  "mfa-begin-enroll-options": lazy(
    () => import("@/screens/mfa-begin-enroll-options")
  ),
  "mfa-country-codes": lazy(() => import("@/screens/mfa-country-codes")),
  "mfa-detect-browser-capabilities": lazy(
    () => import("@/screens/mfa-detect-browser-capabilities")
  ),
  "mfa-email-challenge": lazy(() => import("@/screens/mfa-email-challenge")),
  "mfa-email-list": lazy(() => import("@/screens/mfa-email-list")),
  "mfa-enroll-result": lazy(() => import("@/screens/mfa-enroll-result")),
  "mfa-login-options": lazy(() => import("@/screens/mfa-login-options")),
  "mfa-otp-challenge": lazy(() => import("@/screens/mfa-otp-challenge")),
  "mfa-otp-enrollment-code": lazy(
    () => import("@/screens/mfa-otp-enrollment-code")
  ),
  "mfa-otp-enrollment-qr": lazy(
    () => import("@/screens/mfa-otp-enrollment-qr")
  ),
  "mfa-phone-challenge": lazy(() => import("@/screens/mfa-phone-challenge")),
  "mfa-phone-enrollment": lazy(() => import("@/screens/mfa-phone-enrollment")),
  "mfa-push-challenge-push": lazy(
    () => import("@/screens/mfa-push-challenge-push")
  ),
  "mfa-push-enrollment-qr": lazy(
    () => import("@/screens/mfa-push-enrollment-qr")
  ),
  "mfa-push-list": lazy(() => import("@/screens/mfa-push-list")),
  "mfa-push-welcome": lazy(() => import("@/screens/mfa-push-welcome")),
  "mfa-recovery-code-challenge": lazy(
    () => import("@/screens/mfa-recovery-code-challenge")
  ),
  "mfa-recovery-code-challenge-new-code": lazy(
    () => import("@/screens/mfa-recovery-code-challenge-new-code")
  ),
  "mfa-recovery-code-enrollment": lazy(
    () => import("@/screens/mfa-recovery-code-enrollment")
  ),
  "mfa-sms-challenge": lazy(() => import("@/screens/mfa-sms-challenge")),
  "mfa-sms-enrollment": lazy(() => import("@/screens/mfa-sms-enrollment")),
  "mfa-sms-list": lazy(() => import("@/screens/mfa-sms-list")),
  "mfa-voice-challenge": lazy(() => import("@/screens/mfa-voice-challenge")),
  "mfa-voice-enrollment": lazy(() => import("@/screens/mfa-voice-enrollment")),
  "mfa-webauthn-change-key-nickname": lazy(
    () => import("@/screens/mfa-webauthn-change-key-nickname")
  ),
  "mfa-webauthn-enrollment-success": lazy(
    () => import("@/screens/mfa-webauthn-enrollment-success")
  ),
  "mfa-webauthn-error": lazy(() => import("@/screens/mfa-webauthn-error")),
  "mfa-webauthn-not-available-error": lazy(
    () => import("@/screens/mfa-webauthn-not-available-error")
  ),
  "mfa-webauthn-platform-challenge": lazy(
    () => import("@/screens/mfa-webauthn-platform-challenge")
  ),
  "mfa-webauthn-platform-enrollment": lazy(
    () => import("@/screens/mfa-webauthn-platform-enrollment")
  ),
  "mfa-webauthn-roaming-challenge": lazy(
    () => import("@/screens/mfa-webauthn-roaming-challenge")
  ),
  "mfa-webauthn-roaming-enrollment": lazy(
    () => import("@/screens/mfa-webauthn-roaming-enrollment")
  ),
  "organization-picker": lazy(() => import("@/screens/organization-picker")),
  "organization-selection": lazy(
    () => import("@/screens/organization-selection")
  ),
  "passkey-enrollment": lazy(() => import("@/screens/passkey-enrollment")),
  "passkey-enrollment-local": lazy(
    () => import("@/screens/passkey-enrollment-local")
  ),
  "phone-identifier-challenge": lazy(
    () => import("@/screens/phone-identifier-challenge")
  ),
  "phone-identifier-enrollment": lazy(
    () => import("@/screens/phone-identifier-enrollment")
  ),
  "redeem-ticket": lazy(() => import("@/screens/redeem-ticket")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-email": lazy(() => import("@/screens/reset-password-email")),
  "reset-password-error": lazy(() => import("@/screens/reset-password-error")),
  "reset-password-mfa-email-challenge": lazy(
    () => import("@/screens/reset-password-mfa-email-challenge")
  ),
  "reset-password-mfa-otp-challenge": lazy(
    () => import("@/screens/reset-password-mfa-otp-challenge")
  ),
  "reset-password-mfa-phone-challenge": lazy(
    () => import("@/screens/reset-password-mfa-phone-challenge")
  ),
  "reset-password-mfa-push-challenge-push": lazy(
    () => import("@/screens/reset-password-mfa-push-challenge-push")
  ),
  "reset-password-mfa-recovery-code-challenge": lazy(
    () => import("@/screens/reset-password-mfa-recovery-code-challenge")
  ),
  "reset-password-mfa-sms-challenge": lazy(
    () => import("@/screens/reset-password-mfa-sms-challenge")
  ),
  "reset-password-mfa-voice-challenge": lazy(
    () => import("@/screens/reset-password-mfa-voice-challenge")
  ),
  "reset-password-mfa-webauthn-platform-challenge": lazy(
    () => import("@/screens/reset-password-mfa-webauthn-platform-challenge")
  ),
  "reset-password-mfa-webauthn-roaming-challenge": lazy(
    () => import("@/screens/reset-password-mfa-webauthn-roaming-challenge")
  ),
  "reset-password-request": lazy(
    () => import("@/screens/reset-password-request")
  ),
  "reset-password-success": lazy(
    () => import("@/screens/reset-password-success")
  ),
  signup: lazy(() => import("@/screens/signup")),
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "signup-password": lazy(() => import("@/screens/signup-password")),
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
